import React, {useEffect, useRef} from "react";
import SquareButton from "../SquareButton";
import gallery from "../../Icons/gallery.svg";

import "./ImageSelectorButton.css";


import "./StartScreen.css";

type StartScreenProps = {
    predictCanvas: (canvas: HTMLCanvasElement) => void;
    image: File;
    setImageFile: (image: File | null) => void;
}



type ImageSelectorButtonProps = {
    setImageFile: (image: File | null) => void;
    imageFile: File | null;
};

// Component for displaying our selected image file for prediction
function StartScreen({setImageFile, imageFile}: ImageSelectorButtonProps) {

    // ref to the hidden file input element
    const fileInput = useRef<HTMLInputElement>(null);

    // if we have a null file (from clearing the image), clear the file input value
    useEffect(
        () => {
            if (!imageFile && fileInput.current) {
                fileInput.current.value = "";
            }
        },
        [imageFile, fileInput]
    )

    // make an onclick that will open the file dialog
    const onClick = () => {
        if (fileInput.current) {
            fileInput.current.click();
        }
    }

    // set our image file from the picker
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            setImageFile(files[0]);
        }
    }



    const canvas = useRef<HTMLCanvasElement>(null);
    const display = useRef<HTMLDivElement>(null);

 

    return (
        <div className = 'start-screen'>
            <div className = 'center-modal'
            onClick={onClick}>

            <h1>Add a photo</h1>
            </div>
            <input ref={fileInput} type="file" accept="image/*" onChange={onChange} style={{display: "none"}} />
        </div>
    )
}


export default StartScreen;
